export default __webpack_public_path__ + "img/02217942d3758e9e871d200fbb4dc2e1.svg";